import { observer, use$ } from '@legendapp/state/react';
import { Button, Modal, Stack, Text } from '@mantine/core';
import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { configurationState$ } from '../state';
import { freeBetState$ } from '../state/free-bet.state';

export const FreeBetsStartModal = observer(() => {
  const { t } = useTranslation();

  const [isOpen, setIsOpen] = useState(false);

  const bonusAmount = use$(freeBetState$.bonusAmount);
  const bonusCount = use$(freeBetState$.bonusCount);
  const currency = use$(configurationState$.currency);

  const formatter = useMemo(
    () =>
      new Intl.NumberFormat('en-u-nu-latn', {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
        useGrouping: false,
      }),
    []
  );

  useEffect(() => {
    setIsOpen(freeBetState$.isActive.peek());
  }, []);

  return (
    <Modal
      centered={true}
      closeOnClickOutside={false}
      closeOnEscape={false}
      data-test-id="free-bets-start-modal"
      onClose={() => {
        setIsOpen(false);
      }}
      opened={isOpen}
      radius={24}
      size="xs"
      styles={{
        body: {
          paddingLeft: 32,
          paddingRight: 32,
          paddingTop: 48,
          paddingBottom: 48,
        },
      }}
      withCloseButton={false}
    >
      <Stack gap={24}>
        <Stack align="center" gap={4}>
          <Text c="#f6f6f9" fw={600} fz={24} lh="29px">
            {t('freeBetsStartModal.title')}
          </Text>
        </Stack>

        <Stack align="center" gap={4}>
          <Text c="#f6f6f9" fw={500} fz={14} lh="17px">
            {t('freeBetsStartModal.labels.available')}
          </Text>

          <Text c="#4ade80" fw={600} fz={24} lh="29px">
            {bonusCount}x {formatter.format(bonusAmount)} {currency}
          </Text>
        </Stack>

        <Button
          onClick={() => {
            setIsOpen(false);
          }}
        >
          {t('freeBetsStartModal.buttons.close')}
        </Button>
      </Stack>
    </Modal>
  );
});
